<button type="button" (click)="toggle()"
  [disabled]="isDisabled"
  
  class="transition-all duration-200 w-10 h-10 bg_color p-2 text_green hover:text_black rounded-full hover:button_color_customize hover:template_color_customize relative">
  <span class="sr-only">View notifications</span>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-cash">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
    <path d="M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z" />
    <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
  </svg>

  <!-- Bullet de alerta -->
  <span *ngIf="newNoti && !isDisabled" class="absolute top-0 right-0 h-2.5 w-2.5 bg_red rounded-full"></span>
</button>

<app-modal-cajero [show]="show" (toggle)="closeModal()"> </app-modal-cajero> 